export const COMPLIANCE_LINKS = [
  { label: 'Preferências de Cookies', type: 'cookie-preferences' },
  { label: 'Política de Privacidade', href: '/privacy', type: 'link' },
  { label: 'Política de Cookies', href: '/cookies', type: 'link' },
  { label: 'Termos de Uso', href: '/terms', type: 'link' },
] as const;
